import Field, { inputClass } from '../../common/Field'
import { useWizard } from '../../../context/WizardContext'
import { FIELDS, MESSAGES } from '../../../utils/copy'

/**
 * Step 7 — a time, for the customers who have one in mind.
 *
 * Skippable, and most orders skip it: *now* is what people mean when they order lunch.
 * It is here because some do not — medicine before a clinic appointment, a cake for six
 * o'clock — and on the old form those customers had nowhere to say so.
 *
 * The floor is the current minute rather than the current day, so the picker itself
 * refuses a time already past instead of leaving it to a validator the customer only
 * meets after pressing Continue.
 */

/** `datetime-local` speaks local wall-clock with no zone. `toISOString` is UTC — wrong here. */
const nowForInput = () => {
  const at = new Date()
  const pad = (value) => String(value).padStart(2, '0')

  return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`
    + `T${pad(at.getHours())}:${pad(at.getMinutes())}`
}

export default function TimingStep() {
  const { state, errors, setField } = useWizard()
  const floor = nowForInput()

  return (
    <div className="grid gap-4">
      <p className="text-label font-semibold uppercase text-ink-3">{MESSAGES.optional}</p>

      <Field id="pickupTime" label={FIELDS.pickupTime} error={errors.pickupTime}>
        <input
          id="pickupTime"
          type="datetime-local"
          min={floor}
          value={state.pickupTime}
          onChange={(event) => setField('pickupTime', event.target.value)}
          aria-invalid={Boolean(errors.pickupTime)}
          aria-describedby={errors.pickupTime ? 'pickupTime-error' : undefined}
          className={inputClass(errors.pickupTime)}
        />
      </Field>

      <Field id="deliveryTime" label={FIELDS.deliveryTime} error={errors.deliveryTime}>
        <input
          id="deliveryTime"
          type="datetime-local"
          // Never before the pickup it follows, so the two boxes cannot disagree.
          min={state.pickupTime || floor}
          value={state.deliveryTime}
          onChange={(event) => setField('deliveryTime', event.target.value)}
          aria-invalid={Boolean(errors.deliveryTime)}
          aria-describedby={errors.deliveryTime ? 'deliveryTime-error' : undefined}
          className={inputClass(errors.deliveryTime)}
        />
      </Field>
    </div>
  )
}
